import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Pause, Play, ChevronLeft, ChevronRight, ExternalLink } from "lucide-react";
import api from "../../lib/api";

export function InkWireBar() {
  const [items, setItems] = useState([]);
  const [idx, setIdx] = useState(0);
  const [paused, setPaused] = useState(false);
  const timer = useRef(null);
  const reduced = typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  useEffect(() => {
    api.get("/inkwire/live").then((r) => {
      if (!r.data.paused) setItems(r.data.items || []);
    }).catch(() => {});
  }, []);

  useEffect(() => {
    if (paused || reduced || items.length === 0) return;
    timer.current = setInterval(() => setIdx((i) => (i + 1) % items.length), 4500);
    return () => clearInterval(timer.current);
  }, [paused, reduced, items]);

  if (items.length === 0) return null;
  const cur = items[idx];
  const go = (d) => setIdx((i) => (i + d + items.length) % items.length);

  return (
    <div className="w-full bg-pti-black text-white border-b border-neutral-800" data-testid="inkwire-live-bar" role="region" aria-label="InkWire live headlines">
      <div className="pti-container flex items-center h-11 gap-3">
        <span className="flex items-center gap-2 bg-pti-red px-2.5 py-1 text-[11px] font-extrabold uppercase tracking-[0.15em] shrink-0">
          <span className="w-2 h-2 rounded-full bg-white animate-pulse" aria-hidden="true" />
          INKWIRE LIVE
        </span>

        <a
          href={cur.link}
          target="_blank"
          rel="noopener noreferrer"
          title={cur.title}
          data-testid="inkwire-headline"
          className="flex-1 min-w-0 flex items-center gap-2 text-sm group"
          key={cur.id}
          aria-live="polite"
        >
          <span className="hidden sm:inline text-pti-red text-[11px] font-bold uppercase tracking-wider shrink-0">{cur.category}</span>
          <span className="hidden md:inline text-neutral-500 text-xs shrink-0">{cur.source}</span>
          <span className="flex-1 min-w-0 truncate font-medium group-hover:text-pti-red transition-colors pti-slide-fade">{cur.title}</span>
          <ExternalLink size={12} className="hidden sm:inline opacity-50 shrink-0" aria-hidden="true" />
        </a>

        <div className="flex items-center gap-1 shrink-0">
          <button onClick={() => go(-1)} data-testid="inkwire-prev" aria-label="Previous headline" className="p-1 hover:text-pti-red"><ChevronLeft size={16} /></button>
          <button onClick={() => setPaused(!paused)} data-testid="inkwire-pause" aria-label={paused ? "Play headlines" : "Pause headlines"} className="p-1 hover:text-pti-red">
            {paused ? <Play size={14} /> : <Pause size={14} />}
          </button>
          <button onClick={() => go(1)} data-testid="inkwire-next" aria-label="Next headline" className="p-1 hover:text-pti-red"><ChevronRight size={16} /></button>
          <Link to="/inkwire" data-testid="inkwire-view" className="hidden sm:inline text-[11px] font-bold uppercase tracking-wider text-neutral-400 hover:text-white ml-2 border-l border-neutral-700 pl-3">View InkWire</Link>
        </div>
      </div>
    </div>
  );
}
